import { render, staticRenderFns } from "./HomeCadu.vue?vue&type=template&id=159ba37b&scoped=true"
import script from "./HomeCadu.vue?vue&type=script&lang=js"
export * from "./HomeCadu.vue?vue&type=script&lang=js"
import style0 from "./HomeCadu.vue?vue&type=style&index=0&id=159ba37b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159ba37b",
  null
  
)

export default component.exports